// Google Play compliance flag — the entire Coins/Rewards/Wallet/Boost system
// is WEB-ONLY. Disabled when:
//  1. running inside the native Android/iOS shell (runtime detection), or
//  2. REACT_APP_COINS_DISABLED=true was baked at build time (AAB builds).
import { Capacitor } from '@capacitor/core';

export const COINS_DISABLED =
  process.env.REACT_APP_COINS_DISABLED === 'true' || Capacitor.isNativePlatform();

const COIN_NOTIF_TYPES = new Set([
  'referral_reward', 'cashback_transaction', 'seller_volume_bonus',
  'social_sharing', 'fast_responder', 'milestone_reached',
  'unlock_approved', 'unlock_rejected', 'payment_approved', 'payment_rejected',
  'boost_activated', 'boost_expired', 'coins_earned', 'daily_checkin',
]);

const COIN_TEXT_RE = /(coin|عملات|عملة|boost|تعزيز|مكافأة|reward)/i;

export function isCoinNotification(n) {
  if (!n) return false;
  if (COIN_NOTIF_TYPES.has(n.type)) return true;
  return COIN_TEXT_RE.test(`${n.title || ''} ${n.message || ''} ${n.body || ''}`);
}
